import * as React from "react";
function SvgVaccines(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.657 1.686l5.657 5.657-1.415 1.414-2.12-2.121-1.415 1.414 3.535 3.536L19.485 13l-1.414-1.414-2.822 2.822-.006.006-.007.006-2.108 2.109-.007.006-.007.008-2.821 2.82a1 1 0 01-1.414 0L7.464 17.95 3.93 21.485a1 1 0 01-1.414-1.414l3.535-3.536-1.414-1.414a1 1 0 010-1.414l7.778-7.778L11 4.515 12.414 3.1l3.536 3.536 1.414-1.414L15.243 3.1l1.414-1.414zM8.176 15.833l-.004-.005-.005-.004-1.41-1.41 7.071-7.07.708.706 1.414 1.414.707.707-2.121 2.122-.708-.707A1 1 0 1012.414 13l.707.707-.707.707-.707-.707a1 1 0 00-1.414 1.414l.707.707-1.414 1.415-1.41-1.41z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgVaccines);
export default ForwardRef;
